export const LOGIN_ERROR_KEYS = {
  emptyWorkspaces: "emptyWorkspaces",
};
